import { events } from '@/app/events/events';
import * as gridSettings from '@/app/gridGL/pixiApp/gridSettings';
import { pixiApp } from '@/app/gridGL/pixiApp/PixiApp';
import { getCSSVariableTint } from '@/app/helpers/convertColor';
import { Graphics } from 'pixi.js';

export class CellsCodeOutlines extends Graphics {
  private codeOutlines: { x: number; y: number; width: number; height: number }[] = [];

  constructor() {
    super();
    events.on('gridSettings', this.draw);
  }

  destroy() {
    events.off('gridSettings', this.draw);
    super.destroy();
  }

  update(codeOutlines: { x: number; y: number; width: number; height: number }[]) {
    this.codeOutlines = codeOutlines;
    this.draw();
  }

  private draw = () => {
    if (this.destroyed) return;

    this.clear();
    if (this.codeOutlines.length === 0) return;
    if (!gridSettings.showCellTypeOutlines()) {
      pixiApp.setViewportDirty();
      return;
    }

    const tint = getCSSVariableTint('muted-foreground');
    this.lineStyle({ color: tint, width: 1, alignment: 0.5 });

    this.codeOutlines.forEach((rect) => {
      this.drawRect(rect.x, rect.y, rect.width, rect.height);
    });

    pixiApp.setViewportDirty();
  };
}
